import LoginEntries from 'Modals/LoginEntries';
import React, { useEffect, useState } from 'react'
import { Panel, ViewSwitch, DataTable, cell, rangeLabelOf } from './AdminAnalyticsUI';

// role: 2 professional, 1 client, 0 admin
const ROLE_TABS = [
  { key: 2, label: 'Professionals' },
  { key: 1, label: 'Clients' },
  { key: 0, label: 'Admins' },
];

const getUserDets = (arr) => {
  let returnObj = { loginCount: 0 };
  arr.forEach((i) => {
    returnObj.name = i.name;
    returnObj.email = i.email;
    returnObj.role = i.role;
    returnObj.loginCount = parseInt(returnObj.loginCount) + (parseInt(i.loginCount) || 0);
  });
  return returnObj;
};

function ActiveUserInLoginActivity({userData, date}) {
    const [userListData, setUserListData] = useState({});
    const [currentLoginDets, setCurrentLoginDets] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showTabs, setShowTabs] = useState(2);

    useEffect(() => {
        const userList = {};
        userData && userData?.forEach((user) => {
            Object.entries(user.users || {})?.forEach(([label, value]) => {
                userList[label] = userList[label] ? userList[label] : [];
                userList[label].push({...value, "created_at": user.created_at});
            })
        })
        setUserListData(userList);
    },[userData]);

    const rows = Object.entries(userListData)
      .map(([id, entries]) => ({ _rowKey: id, entries, ...getUserDets(entries) }))
      .filter((r) => r.role === showTabs);

    const columns = [
      { label: 'Name', width: 'minmax(0,1.2fr)', sortVal: (r) => (r.name || '').toLowerCase(), render: (r) => <div className='truncate' style={cell.primary}>{r.name || '—'}</div> },
      { label: 'Email', width: 'minmax(0,1.6fr)', sortVal: (r) => (r.email || '').toLowerCase(), render: (r) => <div className='truncate' style={cell.muted}>{r.email || '—'}</div> },
      { label: 'Logins', width: '90px', right: true, sortVal: (r) => r.loginCount, render: (r) => <span style={cell.num(r.loginCount)}>{r.loginCount}</span> },
    ];

  return (
    <>
    {
        showModal &&
        <LoginEntries
        uploadNew={showModal}
        value={currentLoginDets}
        onClose={() => setShowModal(false)}
        />
    }
    <Panel
      title="Who signed in"
      right={<span style={{ fontSize: '12px', color: 'rgba(20,33,61,.5)' }}>{rangeLabelOf(date)}</span>}
    >
      <div style={{ marginBottom: '16px' }}>
        <ViewSwitch options={ROLE_TABS} value={showTabs} onChange={setShowTabs} />
      </div>
      <DataTable
        key={showTabs}
        columns={columns}
        rows={rows}
        minWidth={520}
        emptyText="No sign-ins for this range"
        onRowClick={(r) => { setCurrentLoginDets(r.entries); setShowModal(true); }}
      />
    </Panel>
    </>
  )
}

export default ActiveUserInLoginActivity
